import { Link, useNavigate } from 'react-router-dom'
import { ExclamationTriangleIcon, ArrowLeftIcon, HomeIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../core/hooks/useTranslation'
import Footer from '../../components/layout/Footer'
import Header from '../../components/layout/Header'

export default function NotFoundPage() {
  const { t, isRTL } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Bar */}
      <Header headerIsSticky={false} />

      {/* Main Content - Centered Layout with Image Background */}
      <div className="min-h-[calc(100vh-73px)] flex items-center justify-center relative overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="/assets/images/background_overlay.webp"
            alt="Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#1E293B]/95 via-[#1E293B]/90 to-[#1E293B]/95"></div>
        </div>

        {/* Content */}
        <div className="relative z-20 w-full max-w-md mx-auto px-6 py-12">
          {/* Not Found Card */}
          <div className="bg-white/95 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-8 space-y-6">
            {/* Icon */}
            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-yellow-100 rounded-full blur-xl opacity-50 animate-pulse" />
                <div className="relative flex items-center justify-center h-24 w-24 rounded-full bg-gradient-to-br from-yellow-50 to-yellow-100 border-4 border-yellow-200 shadow-lg">
                  <ExclamationTriangleIcon className="h-12 w-12 text-yellow-600" />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="text-center space-y-3">
              <h1 className="text-2xl lg:text-3xl font-bold text-[#1E293B]">
                {t('notFoundTitle')}
              </h1>
              <p className="text-sm lg:text-base text-gray-700 leading-relaxed">
                {t('notFoundDescription')}
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t('notFoundMessage')}
              </p>
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-4 pt-4">
              <button
                onClick={handleGoBack}
                className="flex items-center justify-center gap-2 w-full py-3.5 px-6 bg-gradient-to-r from-[#1E293B] to-[#0F172A] text-white text-sm font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0F172A] hover:to-[#020617] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <ArrowLeftIcon className={`h-5 w-5 ${isRTL ? 'rotate-180' : ''}`} />
                {t('notFoundGoBack')}
              </button>
              
              <Link to="/">
                <button className="flex items-center justify-center gap-2 w-full py-3.5 px-6 border-2 border-[#1E293B] text-[#1E293B] text-sm font-semibold rounded-xl hover:bg-[#1E293B]/10 hover:border-[#0F172A] hover:text-[#0F172A] transition-all duration-300">
                  <HomeIcon className="h-5 w-5" />
                  {t('notFoundGoToHome')}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer variant="compact" />
    </div>
  )
}
